// @ts-check
import { ref, onMounted, onUnmounted, readonly } from 'vue'

/**
 * @typedef {import('vue').Ref<Element | null>} ElementRef
 * @typedef {import('vue').DeepReadonly<ElementRef>} ReadonlyElementRef
 */

/**
 * 현재 문서(document)에서 활성화된(포커스된) 요소를 실시간으로 추적합니다.
 * @returns {{activeElement: ReadonlyElementRef}}
 */
export function useActiveElement() {
  /** @type {ElementRef} */
  const activeElement = ref(null)

  const update = () => {
    activeElement.value = document.activeElement
  }

  onMounted(() => {
    update()
    document.addEventListener('focusin', update)
    document.addEventListener('focusout', update)
  })

  onUnmounted(() => {
    document.removeEventListener('focusin', update)
    document.removeEventListener('focusout', update)
  })

  return {
    activeElement: readonly(activeElement)
  }
}













